import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './BookmarksList.styled';
import NoSsr from '@/components/NoSsr/NoSsr';
import { Ad } from '@/api/types/common.types';
import { formatNumber } from '@/utils/helpers';
import { getMessageTime } from '@/utils/datetime.utils';
import { AdCardNew } from '@/components/AdCardNew/AdCardNew';

interface BookmarksListProps {
  bookmarks: Ad[];
  loading: boolean;
  selectedBookmarks: string[];
  onToggleSelection: (bookmarkId: string) => void;
}

export const BookmarksList = forwardRef<HTMLDivElement, BookmarksListProps>(
  ({ bookmarks, selectedBookmarks, onToggleSelection, loading }, ref) => {
    const { i18n } = useTranslation();

    if (loading) {
      return (
        <S.List>
          {Array.from({ length: 8 }).map((_, index) => (
            <AdCardNew key={index} />
          ))}
        </S.List>
      );
    }

    return (
      <S.List ref={ref}>
        {bookmarks.map(bookmark => (
          <S.Item
            key={bookmark.legacyResourceId}
            onClick={() => onToggleSelection(String(bookmark.legacyResourceId))}
          >
            <S.ItemImageWrapper>
              <S.ItemImage src={bookmark.photo.url} />
            </S.ItemImageWrapper>
            <S.ItemInfo>
              {bookmark.price !== null && (
                <S.ItemPrice data-testid="ad-card-price">
                  {formatNumber(bookmark.price, 2, true) || 0} AZN
                </S.ItemPrice>
              )}
              <S.ItemTitle>{bookmark.title}</S.ItemTitle>
              <S.ItemDateAndRegion>
                {`${bookmark.region}, `}
                <NoSsr>
                  {getMessageTime(new Date(bookmark.updatedAt), i18n, true)}
                </NoSsr>
              </S.ItemDateAndRegion>
            </S.ItemInfo>
            <S.ItemCheckbox
              $isChecked={selectedBookmarks?.includes(
                String(bookmark.legacyResourceId)
              )}
            />
          </S.Item>
        ))}
      </S.List>
    );
  }
);

BookmarksList.displayName = 'BookmarksList';
